import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { i18n } from "../../translate/i18n";

import { Slider } from "@mui/material";
import { ModalTitle, FormField } from "../QueueIntegrationModal/panelKit";
import { useFlowModalStyles } from "../FlowBuilderModal/flowModalStyles";

const FlowBuilderRandomizerModal = ({
  open,
  onSave,
  data,
  onUpdate,
  close
}) => {
  const flow = useFlowModalStyles();
  const isMounted = useRef(true);

  const [percent, setPercent] = useState(0);
  const [activeModal, setActiveModal] = useState(false);
  

  useEffect(() => {
    if (open === "edit") {
      setPercent(data.data.percent);
      setActiveModal(true);
    } else if (open === "create") {
      setPercent(0);
      setActiveModal(true);
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleValue = (event, newValue) => {
    setPercent(newValue)
  }

  const handleSaveContact = async values => {
    if (!percent || parseInt(percent) <= 0) {
      return toast.error("Adicione o valor de intervalo");
    }
    if (parseInt(percent) > 120) {
      return toast.error("Máximo de tempo atingido 120 segundos");
    }
    if (open === "edit") {
      onUpdate({
        ...data,
        data: { percent: percent }
      });
    } else if (open === "create") {
      onSave({
        percent: percent
      });
    }
    handleClose();
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={
          open === "create"
            ? `Adicionar um randomizador ao fluxo`
            : `Editar randomizador`
        }
        subtitle="Divide os contatos entre duas saídas, na proporção escolhida."
        onClose={handleClose}
      />
      <DialogContent>
        <FormField label="Proporção entre as saídas">
          <div className={flow.sliderRow}>
            <span className={flow.sliderValue}>{percent}%</span>
            <Slider
              aria-label="Proporção entre as saídas"
              defaultValue={percent}
              valueLabelDisplay="auto"
              onChange={handleValue}
              step={10}
              marks
              min={0}
              max={100}
            />
            <span className={flow.sliderValue}>{100 - percent}%</span>
          </div>
          <div className={flow.sliderCaption}>
            <span>Primeira saída</span>
            <span>Segunda saída</span>
          </div>
        </FormField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={() => handleSaveContact()}
        >
          {open === "create" ? `Adicionar` : "Editar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderRandomizerModal;
